module.exports = __webpack_public_path__ + "static/img/shared-betting-history-double-bg.ce9f47d.png";